var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "invoice-step-details" },
    [
      _vm.hiddenMessage
        ? _c(
            "div",
            {
              staticClass:
                "text-notification border rounded-lg flex items-center px-4 py-2 mb-7",
            },
            [
              _c("div", { staticClass: "grow flex items-center mr-1.5" }, [
                _c("span", { staticClass: "icon mr-1.5 block" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "16",
                        height: "16",
                        viewBox: "0 0 16 16",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM8.5 11.375C8.5 11.4438 8.44375 11.5 8.375 11.5H7.625C7.55625 11.5 7.5 11.4438 7.5 11.375V7.125C7.5 7.05625 7.55625 7 7.625 7H8.375C8.44375 7 8.5 7.05625 8.5 7.125V11.375ZM8 6C7.80374 5.99599 7.61687 5.91522 7.47948 5.775C7.3421 5.63478 7.26515 5.4463 7.26515 5.25C7.26515 5.0537 7.3421 4.86522 7.47948 4.725C7.61687 4.58478 7.80374 4.50401 8 4.5C8.19626 4.50401 8.38313 4.58478 8.52052 4.725C8.6579 4.86522 8.73485 5.0537 8.73485 5.25C8.73485 5.4463 8.6579 5.63478 8.52052 5.775C8.38313 5.91522 8.19626 5.99599 8 6Z",
                          fill: "#070823",
                        },
                      }),
                    ]
                  ),
                ]),
                _c(
                  "span",
                  { staticClass: "text text-sm font-outfit grow block" },
                  [
                    _vm._v(
                      " Only approved hours may be selected. Please contact your Team Lead for further instructions on rejected hours, or hours that need approval. If the rate amount is not entered in step one, the total amount due before taxes may not be accurate. "
                    ),
                  ]
                ),
              ]),
              _c(
                "button",
                {
                  staticClass: "btn-close ml-auto cursor-pointer block",
                  attrs: { type: "button" },
                  on: { click: _vm.handleMessage },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "14",
                        height: "14",
                        viewBox: "0 0 14 14",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M7.70831 7L11.2972 2.72207C11.3573 2.65098 11.3067 2.54297 11.2138 2.54297H10.1228C10.0585 2.54297 9.99698 2.57168 9.9546 2.6209L6.99464 6.14961L4.03468 2.6209C3.99366 2.57168 3.93214 2.54297 3.86652 2.54297H2.7755C2.68253 2.54297 2.63195 2.65098 2.6921 2.72207L6.28097 7L2.6921 11.2779C2.67863 11.2938 2.66998 11.3132 2.66719 11.3338C2.6644 11.3544 2.66759 11.3754 2.67637 11.3942C2.68515 11.4131 2.69916 11.429 2.71673 11.4402C2.7343 11.4513 2.7547 11.4571 2.7755 11.457H3.86652C3.93077 11.457 3.9923 11.4283 4.03468 11.3791L6.99464 7.85039L9.9546 11.3791C9.99562 11.4283 10.0571 11.457 10.1228 11.457H11.2138C11.3067 11.457 11.3573 11.349 11.2972 11.2779L7.70831 7Z",
                          fill: "black",
                          "fill-opacity": "0.45",
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "mb-4" },
        [
          _c(
            "LoadingOverlay",
            { attrs: { hasData: _vm.hasData, loading: _vm.isLoaded } },
            [
              _c("InvoiceTable", {
                attrs: {
                  headers: _vm.headers,
                  data: _vm.invoiceData,
                  showCheckboxes: true,
                  hoursTable: true,
                },
                on: {
                  showNote: _vm.handleNote,
                  change: _vm.handleSelectionChange,
                },
                model: {
                  value: _vm.selectedItems,
                  callback: function ($$v) {
                    _vm.selectedItems = $$v
                  },
                  expression: "selectedItems",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "text-right" },
        [_c("InvoiceSummary", { attrs: { selectedItems: _vm.selectedItems } })],
        1
      ),
      _c(
        "span",
        {
          staticClass:
            "flex items-center justify-center font-outfit text-base cursor-pointer",
          on: { click: _vm.toggleCheckbox },
        },
        [
          _c(
            "label",
            { staticClass: "custom-checkbox mr-2", attrs: { for: "checkbox" } },
            [
              _c("input", {
                ref: "checkbox",
                attrs: {
                  disabled: _vm.selectedItems.length === 0,
                  type: "checkbox",
                },
                domProps: { checked: _vm.isCheckboxChecked },
                on: { change: _vm.handleCheckboxChange },
              }),
              _c("span", { staticClass: "icon-checked" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "11",
                      height: "9",
                      viewBox: "0 0 11 9",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M1.91308 4.03516H1.91326C1.99256 4.03525 2.07081 4.05331 2.14213 4.08798C2.21341 4.12262 2.27591 4.17295 2.32497 4.2352L1.91308 4.03516ZM1.91308 4.03516H1.09394C0.890308 4.03516 0.776602 4.26975 0.902321 4.4292L0.902371 4.42927L4.11214 8.49567L4.11218 8.49573C4.32247 8.76188 4.72568 8.76114 4.93667 8.49617L4.93708 8.49566L10.6597 1.24398C10.6598 1.24378 10.66 1.24358 10.6602 1.24338C10.7884 1.08295 10.6699 0.85 10.4689 0.85H9.6498C9.48941 0.85 9.33668 0.9235 9.2376 1.05044C9.23751 1.05055 9.23742 1.05066 9.23734 1.05077L4.52403 7.02157M1.91308 4.03516L4.52403 7.02157M4.52403 7.02157L2.32506 4.23531L4.52403 7.02157Z",
                        fill: "white",
                        stroke: "white",
                        "stroke-width": "0.3",
                      },
                    }),
                  ]
                ),
              ]),
            ]
          ),
          _vm._v(
            " I acknowledge that ProveraCare does not calculate taxes, and I am responsible for adding and remitting taxes as required by applicable laws. "
          ),
        ]
      ),
      _c("div", { staticClass: "invoice-form-button" }, [
        _c(
          "div",
          { staticClass: "invoice-form-button-wrap" },
          [
            _c("UiButton", {
              attrs: {
                buttonText: "Cancel",
                buttonClasses:
                  "px-2 pr-3.5 pl-3.5 customHeight40 invoice-steps-buttons",
                variant: "white",
              },
              on: { click: _vm.handleCancel },
            }),
            _c("UiButton", {
              attrs: {
                type: "button",
                buttonText: "Continue",
                buttonClasses:
                  "px-2 pr-3.5 pl-3.5 customHeight40 invoice-steps-buttons",
                variant: "black",
                disabled:
                  !_vm.isCheckboxChecked || _vm.selectedItems.length === 0,
              },
              on: { click: _vm.handleContinue },
            }),
          ],
          1
        ),
      ]),
      _vm.showNoteModal
        ? _c("NoteModal", {
            attrs: { message: _vm.note, taskName: _vm.taskName },
            on: {
              close: function ($event) {
                _vm.showNoteModal = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }